import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@tes/ui';
import { messageOf } from '../lib/errors';

/**
 * Router-level error boundary. Without one, a render error anywhere in the
 * tree unmounts the whole app to a blank page; this keeps the failure on
 * screen with a way back.
 */
export function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();
  const title = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : 'Something went wrong';
  const detail = isRouteErrorResponse(error)
    ? typeof error.data === 'string'
      ? error.data
      : ''
    : messageOf(error, 'An unexpected error occurred.');

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-8 font-sans">
      <div className="w-full max-w-md space-y-4 rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        <div className="flex items-center gap-2 text-red-600">
          <AlertTriangle size={20} />
          <h1 className="text-lg font-semibold text-slate-900">{title}</h1>
        </div>
        {detail && <p className="break-words text-sm text-slate-600">{detail}</p>}
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => location.reload()}>
            Reload
          </Button>
          <Button variant="ghost" onClick={() => navigate('/')}>
            Back to templates
          </Button>
        </div>
      </div>
    </div>
  );
}
